// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VyM2g","content":"styles_content__3DP41"};